import { getErrorMessage, getTraceId } from '@shared/api';
import { StatusScreen } from '@shared/ui/status-screen';

import { ERROR_BOUNDARY_TEXT } from './error-boundary.text';

export interface ErrorFallbackProps {
  error: unknown;
  reset: () => void;
  inline?: boolean;
}

export function ErrorFallback({ error, reset, inline = false }: ErrorFallbackProps) {
  const traceId = getTraceId(error);
  return (
    <StatusScreen
      inline={inline}
      title={ERROR_BOUNDARY_TEXT.title}
      description={getErrorMessage(error)}
      {...(traceId ? { traceId } : {})}
      action={{ label: ERROR_BOUNDARY_TEXT.retry, onClick: reset }}
      secondaryAction={{
        label: ERROR_BOUNDARY_TEXT.reload,
        onClick: () => window.location.reload(),
      }}
    />
  );
}
